import { createRoot } from "react-dom/client";
import App from "./app";
import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { darkTheme } from "ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query-client";
import DialogProvider from "./components/dialog-provider";
import { ToastContainer } from "react-toastify";
import { initSentry } from "./sentry";
import { ErrorBoundary } from "./components/error-boundary";

// Initialize Sentry error tracking (only in production)
initSentry();

createRoot(document.getElementById("root") as HTMLElement).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={darkTheme}>
        <GlobalStyles
          styles={{
            ":root": {
              "--toastify-color-dark": "#1A1C1F",
              "--toastify-color-success": "#005140",
              "--toastify-color-error": "#FF897D",
              "--toastify-toast-min-height": "48px",
              colorScheme: "dark",
            },
            ".Toastify__toast": {
              padding: "8px 10px",
            },
            ".Toastify__toast-body": {},
            ".Toastify__toast--success": {
              background: "var(--toastify-color-success)",
              color: "#7EF8D4",
            },
            ".Toastify__toast--error": {
              background: "var(--toastify-color-error)",
              color: "#FFDAD6",
            },
            ".MuiBreadcrumbs-li .MuiLink-root": {
              cursor: "pointer",
            },
          }}
        />
        <CssBaseline />
        <App />
        <DialogProvider />
        <ToastContainer
          theme="dark"
          position="bottom-right"
          icon={false}
          hideProgressBar={true}
          closeButton={false}
        />
      </ThemeProvider>
    </QueryClientProvider>
  </ErrorBoundary>,
);
